import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import Roller from '../../types/api/roller'
import getQuery from '../../helpers/api/get-query'
import RollerWithStampsCount from '../../types/api/roller-with-stamps-count'

export const rollersApi = createApi({
    reducerPath: 'rollersApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Rollers'],
    endpoints: builder => ({
        getRollers: builder.query<Strapi<Roller>, EndpointQueryParameters | void>({
            query: getQuery(`/rollers`),
        }),
        getRollersWithStampsCount: builder.query<RollerWithStampsCount[], void>({
            query: () => `/rollers-with-stamps-count`,
        }),
    }),
})

export const { useGetRollersQuery, useGetRollersWithStampsCountQuery } = rollersApi
